import React from 'react';

export interface DetailRowProps {
  icon: React.ReactNode;
  label: string;
  value: string | React.ReactNode;
  showDivider?: boolean;
}

export const DetailRow: React.FC<DetailRowProps> = ({
  icon,
  label,
  value,
  showDivider = true,
}) => (
  <div
    className={`flex flex-row items-center justify-between py-3 ${
      showDivider ? 'border-b border-gray-200' : ''
    }`}>
    <div className="flex flex-row items-center justify-start gap-2">
      {icon}
      <p className="text-gray-600 text-[14px] font-[400] leading-[22px]">{label}</p>
    </div>
    <div className="text-gray-900 text-[14px] font-[500] leading-[22px]">{value}</div>
  </div>
);
